(function(){
    'use strict';

    angular.module('Services').factory('PubSubService', PubSubService);

    PubSubService.$inject = ['Request'];

    function PubSubService(Request){
        return {
            checkDriverLocation: function(callback, errorCallback){
                Request.get({
                    url: ApiURLs.pubSub.checkDriverLocation,
                    successCallback: callback,
                    errorCallback: errorCallback
                });
            },
            checkDriverStatus: function(callback, errorCallback){
                Request.get({
                    url: ApiURLs.pubSub.checkDriverSatus,
                    successCallback: callback,
                    errorCallback: errorCallback
                });
            }
        }
    }
})()


// WEBPACK FOOTER //
// ./js/services/PubSubService.js